import React from "react";

interface ResponsiveImageProps {
  alt: string;
  images: {
    sm?: string;
    md?: string;
    lg?: string;
    xl?: string;
    "2xl"?: string;
    default: string;
  };
  className?: string;
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  alt,
  images,
  className = "",
}) => {
  return (
    <picture className={className}>
      {images["2xl"] && <source srcSet={images["2xl"]} media="(min-width: 1536px)" />}
      {images["xl"] && <source srcSet={images["xl"]} media="(min-width: 1280px)" />}
      {images["lg"] && <source srcSet={images["lg"]} media="(min-width: 1024px)" />}
      {images["md"] && <source srcSet={images["md"]} media="(min-width: 768px)" />}
      {images["sm"] && <source srcSet={images["sm"]} media="(min-width: 640px)" />}

      <img src={images.default} alt={alt} />
    </picture>
  );
};

export default ResponsiveImage;
